// import Bootstrap from "bootstrap";
// import Vue from "vue";
// import App from "./App.vue";

import { createApp } from "vue";
import App from "./App.vue";

const app = createApp(App);

app.mount("#fund-factsheet");

// Vue.config.productionTip = false

// new Vue({
//   render: (h) => h(App),
// }).$mount("#fund-factsheet");
